"use strict";exports.__esModule=!0,exports.dataKey=void 0;var dataKey="text";exports.dataKey=dataKey;